module.exports = __webpack_public_path__ + "img/pach_yes.300af47c.png";